<template>
  <fragment>
    <!--      STUDY RESULTS-->
    <!-- CHART-->
    <slot name="heading"></slot>
    <table class="table">
      <tr>
        <td class="p-0">
          <slot />
        </td>
      </tr>
    </table>
    <slot name="charts-footer" />
  </fragment>
</template>

<script>
import Api from "@/providers/Api";
import {handleServerErrorWithValidation} from "@/helpers/ToastedHelper";

export default {
  name: 'ReportMarkdownCharts',
  props: {
    study: Object,
  },
  created() {
    this.getReportData();
  },
  methods: {
    getReportData: async function () {
      try {
        this.reportData = await Api.getDataFotReport((this.study || {}).id);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.$nextTick(() => this.$emit('ready'));
      }
    },
  },
};
</script>
